import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  FormsModule as AngularFormsModule,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ChartsModule } from "ng2-charts";
import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import { FilterStoresModule } from "../../../../layout/filter-stores/filter-stores.module";
import { StaticComponent } from "./static.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { QrCodeModule } from "../batchstamp/qr-code/qr-code.module";
import { ImageService } from "../../../imageService";
import { ModalHistoryComponent } from "./modal/modalHistory.component";
import { ModalReportComponent } from "./modal/modalReport.component";
import { StaticStampService } from "app/common/services/StaticStamp.service";
import { EvsStoreService } from "app/common/services/EvsStore.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ChartsModule,
    BsDatepickerModule.forRoot(),
    QrCodeModule,
    FilterProductsModule,
    FilterStoresModule,
  ],
  declarations: [StaticComponent, ModalHistoryComponent, ModalReportComponent],
  providers: [ImageService, StaticStampService, EvsStoreService],
  entryComponents: [ModalHistoryComponent, ModalReportComponent],
})
export class StaticModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/static_stamp/static.module.ts